
  import { defineComponent, PropType } from 'vue';
  import { Omit } from 'lodash';

  import IndicatorCard from '@/common/components/redesigned/IndicatorCard.vue';
  import textMixin from '@/common/mixins/text';

  import { TDashboardDynamicCard } from '../../../types/regionDashboards';

  const indicatorCardsLabels: Record<keyof Omit<TDashboardDynamicCard, 'title'>, string> = {
    plan: 'План',
    fact: 'Факт',
    firstQuarter: 'I кв.',
    secondQuarter: 'II кв.',
    thirdQuarter: 'III кв.',
    fourthQuarter: 'IV кв.',
  };

  type TIndicatorCardParam = {
    text: string;
    value: string;
    status: 'positive' | 'negative' | 'neutral' | null;
  };

  export default defineComponent({
    name: 'RegionDashboardsDynamicCard',
    components: {
      IndicatorCard,
    },
    mixins: [textMixin],
    props: {
      card: {
        type: Object as PropType<TDashboardDynamicCard>,
        required: true,
      },
      year: {
        type: String,
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      indicatorCardParams(): TIndicatorCardParam[] {
        return (Object.entries(indicatorCardsLabels) as [keyof TDashboardDynamicCard, string][]).map(([key, value]) => {
          let text = value;
          const textWithYearKeys: (keyof TDashboardDynamicCard)[] = ['plan', 'fact'];

          if (textWithYearKeys.includes(key)) {
            text = this.getTextWithYear(value);
          }

          return {
            text,
            value: this.card[key] ? this.formatNumber(this.card[key], 1, ' ', ',') : '-',
            status: textWithYearKeys.includes(key)
              ? this.card[key] === null
                ? 'neutral'
                : null
              : this.getQuarterStatus(this.card[key]),
          };
        });
      },
    },
    methods: {
      getTextWithYear(text: string) {
        return `${text} ${this.year}`;
      },
      getQuarterStatus(value: string | number | null): TIndicatorCardParam['status'] {
        if (!value) {
          return 'neutral';
        }

        const parsedValue = parseFloat(value.toString());

        if (parsedValue > 0) {
          return 'positive';
        }

        return 'negative';
      },
    },
  });
